import React from 'react';
import { NavLink } from 'react-router-dom';
import img from '../../images/icons/1.png'
import img2 from '../../images/icons/2.png'

import img3 from '../../images/icons/3.png'
import img4 from '../../images/icons/4.png'
import img5 from '../../images/icons/5.png'
import img6 from '../../images/icons/6.png'
import img7 from '../../images/icons/7.png'
import img8 from '../../images/icons/8.png'
import img9 from '../../images/icons/9.png'
import img10 from '../../images/icons/10.png'

const services = [
    {
        count: '01',
        title: 'Études de faisabilité ',
        flaticon: img ,
        description: "Analyse approfondie des aspects techniques, économiques et environnementaux d'un projet pour déterminer sa viabilité",
    },
    {
        count: '02',
        title: 'Conception préliminaire',
        flaticon: img2,
        description: 'Développement des concepts et des solutions techniques initiales, y compris la sélection des matériaux et des méthodes de construction',
    },
    {
        count: '03',
        title: 'Études de conception détaillée ',
        flaticon: img3,
        description: 'Élaboration des plans, des dessins et des spécifications techniques détaillées pour la réalisation du projet',
    },
    {
        count: '04',
        title: 'Modélisation et simulation',
        flaticon: img5,
        description: "Utilisation de logiciels spécialisés pour modéliser et simuler le comportement des structures sous différentes conditions de chargement et d'environnement.",
    },
    {
        count: '05',
        title: 'Analyse de la structure',
        flaticon: img4,
        description: 'Évaluation des charges, des contraintes et des performances des structures existantes ou proposées, avec recommandations pour leur renforcement ou leur réhabilitation si nécessaire. ',
    },
    {
        count: '06',
        title: 'Gestion de projet ',
        flaticon: img6,
        description: 'Coordination et supervision de toutes les phases du projet, y compris la planification, le suivi des coûts, la gestion des ressources et le respect des délais',
    }, {
        count: '07',
        title: 'Contrôle de la qualité',
        flaticon: img7,
        description: "Mise en place de procédures et d'inspections pour garantir la conformité aux normes et aux spécifications tout au long du processus ",
    }, {
        count: '08',
        title: 'Suivi de chantier ',
        flaticon: img8,
        description: "Supervision sur site pour s'assurer que les travaux sont exécutés conformément aux plans et aux normes établis. Études d'impact environnemental  ",
    }, {
        count: '09',
        title: "Études d'impact environnemental",
        flaticon: img9,
        description: "Évaluation des impacts potentiels d'un projet sur l'environnement et proposition de mesures d'atténuation. ",
    }, {
        count: '10',
        title: 'Consultation et conseil technique',
        flaticon:img10,
        description: "Fourniture de conseils d'experts sur des questions spécifiques liées au génie civil, y compris la résolution de problèmes et l'optimisation des conceptions. Ces services peuvent être adaptés en fonction des besoins spécifiques de chaque projet et de chaque client ",
    }
]

var bgimg1 = require('./../../images/background/cross-line2.png');

class Services1 extends React.Component {
    render() {

        return (
            <>
                <div className="section-full mobile-page-padding p-t80  p-b50 bg-gray">
                    <div className="section-content">
                        <div className="container">
                            {/* TITLE START */}
                            <div className="section-head">
                                <div className="sx-separator-outer separator-left">
                                    <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                                        <h3 className="sep-line-one "> Services</h3>
                                    </div>
                                </div>
                            </div>
                            {/* TITLE END */}
                            <div className="row">
                                {services.map((item, index) => (
                                    <div className="col-lg-4 col-md-6 col-sm-12 m-b30" key={index}>
                                        <div className="sx-icon-box-wraper  icon-count-2-outer">
                                            <div className="icon-count-2 bg-white">
                                                <span className="icon-count-number">{item.count}</span>
                                                <div className="icon-xl inline-icon m-b5 scale-in-center">
                                                    <span className="icon-cell"><img src= {item.flaticon} /></span>
                                                </div>
                                                <div className="icon-content">
                                                    <h4 className="sx-tilte">{item.title}</h4>
                                                    <p>{item.description}</p>
                                                    <div className="text-left">
                                                        <NavLink to={"#"} className="site-button-link">Lire Plus</NavLink>
                                                    </div>
                                                </div>
                                            </div> 
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="hilite-title text-left p-l50 text-uppercase">
                        <strong>Services</strong>
                    </div>
                </div>
            </>
        );
    }
};
export default Services1;